import { Box, xcss } from '@atlaskit/primitives';
import React from 'react';
import { ClearSelectionButton } from '../ClearSelectionButton';
import { jsx as _jsx } from "react/jsx-runtime";
const footerWrapperStyles = xcss({
  borderTopColor: 'color.border',
  borderTopWidth: 'border.width',
  borderTopStyle: 'solid'
});
export const Footer = _ref => {
  let {
    isClearSelectionDisabled,
    onClearSelection
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    xcss: footerWrapperStyles,
    children: /*#__PURE__*/_jsx(ClearSelectionButton, {
      onClick: onClearSelection,
      isDisabled: isClearSelectionDisabled
    })
  });
};